module.exports = __webpack_public_path__ + "static/media/myphoto6.8dfd5c26.jpg";